import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchJob } from "../../features/job/jobSlice";
import Form from "./Form";

const EditJob = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { isLoading, job, isError } = useSelector((state) => state.job) || {};

  useEffect(() => {
    dispatch(fetchJob(id));
  }, [id, dispatch]);

  // render content
  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (isError) {
    content = <div>Error...</div>;
  }

  if (!isLoading && !isError && job !== null) {
    content = <Form job={job} />;
  }

  return (
    <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <h1 className="mb-10 text-center section-title">Edit Job</h1>

      <div className="max-w-3xl mx-auto">{content}</div>
    </main>
  );
};

export default EditJob;
